import React, { useContext } from "react";
import styles from "./styles.module.scss";
import { Spin } from "antd";
import useRequest from "../../../../../../../../utils/useRequest";
import { getExamInfoByStu } from "../../../../../../../../service/exam";
import { InvigilationCtx } from "../../../../../context";

export default function AllStuInfo() {
    const { currentData } = useContext(InvigilationCtx);
    const [data, { loading }] = useRequest(
        () =>
            getExamInfoByStu(
                currentData?.examId.toString() || "",
                currentData?.studentNo || ""
            ),
        {},
        [currentData]
    );

    return (
        <div className={styles.stuInfo}>
            <Spin spinning={loading}>
                <h1 className={styles.title}>考生基本信息</h1>

                <dl className={styles.dl} style={{ marginTop: 30 }}>
                    <dt className={styles.label}>姓名：</dt>

                    <dd className={styles.text1}>{data?.stuName || "--"}</dd>
                </dl>

                <dl className={styles.dl}>
                    <dt className={styles.label}>学号：</dt>

                    <dd className={styles.text1}>{data?.stuNo || "--"}</dd>
                </dl>

                <dl className={styles.dl}>
                    <dt className={styles.label}>性别：</dt>

                    <dd className={styles.text1}>{data?.sex || "--"}</dd>
                </dl>

                <dl className={styles.dl}>
                    <dt className={styles.label}>班级：</dt>

                    <dd className={styles.text1}>{data?.className || "--"}</dd>
                </dl>

                <dl className={styles.dl}>
                    <dt className={styles.label}>专业：</dt>

                    <dd className={styles.text1}>{data?.subject || "--"}</dd>
                </dl>

                <dl className={styles.dl}>
                    <dt className={styles.label}>学院：</dt>

                    <dd className={styles.text1}>{data?.department || "--"}</dd>
                </dl>
            </Spin>
        </div>
    );
}
